export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Gizli panelin token'ı — URL query olarak gönderilir
export const ADMIN_TOKEN = '-VLic1j0CXxKb6xBMIaKZAQ_lKj6cVxuvswKSywrIj4';

// image_url farklı biçimlerde olabilir: dış URL, /public asset, /api/horeca/files/...
export const resolveImg = (u) => {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith('/api/')) return `${BACKEND_URL}${u}`;
  return u;
};
